import React from "react";
import { injectIntl } from "react-intl";
import LoadingOverlay from "react-loading-overlay";
import { useLoadingContext } from "./context";

const LoadingSpinnerOverlay = ({ intl }) => {
  const { loading, progress, message } = useLoadingContext();

  const defaultLoadingMessage =
    progress && progress === 100
      ? intl.formatMessage({ id: "common.processing" })
      : `${intl.formatMessage({ id: "common.loading" })}${progress ? progress + " %" : ""}`;

  return (
    <LoadingOverlay
      styles={{
        wrapper: base => ({
          ...base,
          position: "fixed",
          width: "100%",
          height: "100%",
          zIndex: 2000,
          display: loading ? "block" : "none",
        }),
        content: base => ({
          position: "fixed",
          top: "50%",
          left: "50%",
          marginTop: -50,
        }),
      }}
      active={loading}
      spinner
      text={message || defaultLoadingMessage}
    />
  );
};

export default injectIntl(LoadingSpinnerOverlay);
